/**
 * Checks if the given string is a valid LinkedIn URL.
 */
export const isValidLinkedInUrl = (url: string): boolean => {
    const regex =
        /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|pub|company)\/[a-zA-Z0-9_-]+(\/[a-zA-Z0-9_-]+)*\/?$/
    return regex.test(url)
}

/**
 * Checks if the given string is a valid SAT score
 */
export const isValidSatScore = (score: number): boolean => {
    return score >= 200 && score <= 800 && score % 10 === 0
}

/**
 * Checks if the given string is a valid GRE score
 * @param score the score to validate
 * @param writing boolean indiciating if this is validating a writing score (different validations)
 * @returns boolean indicating if the score is valid
 */
export const isValidGreScore = (
    score: number,
    writing: boolean = false
): boolean => {
    if (writing) return score >= 0 && score <= 6 && score % 0.5 === 0
    return score >= 130 && score <= 170 && score % 1 === 0
}
